'use strict';

import {getCurrentLangDirection} from "../langSwitcher/langSwitcher";
import {isMobile, isTablet} from "../../../settings";
import Swiper from "swiper";
import {EffectCube, Navigation, Pagination} from "swiper/modules";
import { Cloudflare } from '../../api/Cloudflare';
import {BaseElement} from "../../interfaces/BaseElement";

export class OptionsCardGallery {
  constructor(container, picturesArray) {
    this.container = container;
    this.picturesArray = picturesArray;
    this.swiper = null;
    this.galleryContainer = null;
  }

  create() {

    this.galleryContainer = new BaseElement()
      .addClass('swiper', 'options__card__gallery')
      .addAttribute('dir', getCurrentLangDirection())
      .appendTo(this.container)
    const galleryWrapper = new BaseElement()
      .addClass('options__card__gallery__wrapper', 'swiper-wrapper')
      .appendTo(this.galleryContainer.DOMElement);


    this.picturesArray.forEach((picture, index) => {
      let url;

      if (isMobile || isTablet) {
        url = Cloudflare.resize(picture,{
          width: 1024,
          quality: 75
        });
      } else {
        url = Cloudflare.resize(picture,{
          width: 2048,
          quality: 75
        });
      }

      const imgContainer = new BaseElement()
        .addClass('options__card__gallery__img__container', 'swiper-slide')
        .appendTo(galleryWrapper.DOMElement);
      new BaseElement('img')
        .addClass('options__card__gallery__img')
        .event('load', () => { preloaderContainer.remove() })
        .setAttributes({
          'src': url,
          'alt': `Picture-${index}`
        })
        .appendTo(imgContainer.DOMElement);
      const preloaderContainer = new BaseElement()
        .addClass('options__card__gallery__img__preloader')
        .appendTo(imgContainer.DOMElement);
      new BaseElement()
        .addClass('swiper-lazy-preloader', 'swiper-lazy-preloader-white')
        .appendTo(preloaderContainer.DOMElement);
    });

    new BaseElement()
      .addClass('options__card__gallery__pagination', 'swiper-pagination')
      .appendTo(this.galleryContainer.DOMElement);
    new BaseElement()
      .addClass('options__card__gallery__navigation-btn', 'swiper-button-next', 'icon-right1')
      .appendTo(this.galleryContainer.DOMElement);
    new BaseElement()
      .addClass('options__card__gallery__navigation-btn', 'swiper-button-prev', 'icon-left1')
      .appendTo(this.galleryContainer.DOMElement);

    Swiper.use([Pagination, EffectCube, Navigation]);
    this.swiper = new Swiper('.options__card__gallery', {
      effect: this.picturesArray.length > 1 && this.picturesArray.length < 4 ? 'slide' : 'cube',
      loop: this.picturesArray.length > 1,
      spaceBetween: 30,
      pagination: {
        el: '.options__card__gallery__pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: ".options__card__gallery__navigation-btn.swiper-button-next",
        prevEl: ".options__card__gallery__navigation-btn.swiper-button-prev",
      },
    });
  }

  update() {
    this.swiper?.update();
  }

  remove() {
    this.galleryContainer?.remove();
    this.galleryContainer = null;
    this.swiper = null;
  }

  changeDirection() {
    if (!this.swiper) return;
    this.remove();
    this.create();
  }
}
